/** Canonical manifest serialization matching Python's
 *  json.dumps(sort_keys=True, separators=(",",":"), ensure_ascii=False). */

export class ManifestNotCanonicalizable extends Error {}

function hasNonBmp(s: string): boolean {
  // A surrogate pair means a code point outside the BMP.
  for (const ch of s) if (ch.codePointAt(0)! > 0xffff) return true;
  return false;
}

function canonicalize(value: unknown): unknown {
  if (value === null) return null;
  if (typeof value === "number") {
    if (!Number.isInteger(value)) {
      throw new ManifestNotCanonicalizable(`non-integer number: ${value}`);
    }
    return value;
  }
  if (typeof value === "string") {
    if (hasNonBmp(value)) {
      // values are fine non-BMP for JSON output; only KEYS must be BMP.
      return value;
    }
    return value;
  }
  if (typeof value === "boolean") return value;
  if (Array.isArray(value)) return value.map(canonicalize);
  if (typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const key of Object.keys(obj).sort()) {
      if (hasNonBmp(key)) {
        throw new ManifestNotCanonicalizable(`non-BMP key: ${key}`);
      }
      out[key] = canonicalize(obj[key]);
    }
    return out;
  }
  throw new ManifestNotCanonicalizable(`unsupported value: ${typeof value}`);
}

export function canonicalManifestBytes(manifest: unknown): Uint8Array {
  const json = JSON.stringify(canonicalize(manifest));
  return new TextEncoder().encode(json);
}
